import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function userPreferenceUpdate(params) {
    const { baseUrl, brandId, country, uberToken, clientId, preference, body } = params;

    invariant(baseUrl, 'baseUrl is a required param of userPreferenceUpdate()');
    invariant(brandId, 'brandId is a required param of userPreferenceUpdate()');
    invariant(country, 'country is a required param of userPreferenceUpdate()');
    invariant(preference, 'preference is a required param of userPreferenceUpdate()');
    invariant(body, 'body is a required param of userPreferenceUpdate()');
    invariant(uberToken, 'uberToken is a required param of userPreferenceRemove()');
    invariant(clientId, 'clientId is a required param of userPreferenceUpdate()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/userpreferences/${preference}`;

    const jsonBody = JSON.stringify(body);

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body: jsonBody }), uberToken, clientId),
        'userPreferenceUpdate',
    );
}
